import { Children, cloneElement, useContext, useEffect } from 'react'
import { AccordionContext } from 'components/shared/Accordion/utils/accordionContext'
import { StyledAccordionItem } from './AccordionItem.styles'
import { AccordionItemProps } from './AccordionItem.types'
import { useResolutions } from 'store/resolutions'
import { scrollTo } from 'helpers/animateScroll'

export const AccordionItem = ({
    children,
    id,
    isAutoScrolling,
    'data-testid': testId,
}: AccordionItemProps) => {
    const { isMobile } = useResolutions()

    const { expandedItemId } = useContext(AccordionContext)
    const isExpanded = expandedItemId === id

    useEffect(() => {
        if (!isAutoScrolling || !isExpanded) return

        // after expanding item align it's box with the top of the vieport
        scrollTo({
            id: `item-${id}`,
            duration: 500,
            margin: 0,
            isMobile,
        })
    }, [isAutoScrolling, isExpanded])

    return (
        <StyledAccordionItem
            width="100%"
            direction="column"
            id={`item-${id}`}
            {...(isExpanded && { pb: 16 })}
        >
            {Children.map(children, (child) =>
                cloneElement(child, {
                    id,
                    key: id,
                    isExpanded,
                    'data-testid': testId,
                })
            )}
        </StyledAccordionItem>
    )
}
